import { Modifier } from "@dnd-kit/core";
import { getEventCoordinates } from "@dnd-kit/utilities";

export const VERTICAL_DRAG_PASSENGER_CORRECTION = 30;
export const VERTICAL_DRAG_RIDE_CORRECTION = 30;
export const HORIZONTAL_DRAG_CORRECTION = 10;

export const snapMouseToContainer = (
  verticalContainerCorrection: number,
): Modifier => {
  let initialCoordinates: { x: number; y: number } | null = null;
  let initialMouseCoordinates: { x: number; y: number } | null = null;
  let initialDraggingNodeRect: { left: number; top: number } | null = null;

  return ({
    containerNodeRect,
    draggingNodeRect,
    activatorEvent,
    transform,
  }) => {
    if (!draggingNodeRect || !activatorEvent) {
      return transform;
    }

    const activatorCoordinates = getEventCoordinates(activatorEvent);

    if (!activatorCoordinates) {
      return transform;
    }

    // If containerNodeRect is available, use container-based positioning
    if (containerNodeRect) {
      if (!initialCoordinates) {
        initialCoordinates = {
          x: containerNodeRect.left,
          y: containerNodeRect.top,
        };
      }

      const offsetX = activatorCoordinates.x - initialCoordinates.x;
      const offsetY = activatorCoordinates.y - initialCoordinates.y;
      return {
        ...transform,
        x: transform.x + offsetX - HORIZONTAL_DRAG_CORRECTION,
        y: transform.y + offsetY - verticalContainerCorrection,
      };
    }

    // Fallback to cursor-based positioning when containerNodeRect is not available
    if (!initialMouseCoordinates || !initialDraggingNodeRect) {
      initialMouseCoordinates = {
        x: activatorCoordinates.x,
        y: activatorCoordinates.y,
      };
      initialDraggingNodeRect = draggingNodeRect;
    }

    const deltaX = activatorCoordinates.x - initialMouseCoordinates.x;
    const deltaY = activatorCoordinates.y - initialMouseCoordinates.y;

    return {
      ...transform,
      x: transform.x + deltaX - HORIZONTAL_DRAG_CORRECTION,
      y: transform.y + deltaY - verticalContainerCorrection,
    };
  };
};

export const snapMouseToCursor = (
  verticalCorrection: number = 0,
  horizontalCorrection: number = 0,
): Modifier => {
  let initialMouseCoordinates: { x: number; y: number } | null = null;
  let initialDraggingNodeRect: { left: number; top: number } | null = null;

  return ({ draggingNodeRect, activatorEvent, transform }) => {
    if (draggingNodeRect && activatorEvent) {
      const activatorCoordinates = getEventCoordinates(activatorEvent);

      if (!activatorCoordinates) {
        return transform;
      }

      if (!initialMouseCoordinates || !initialDraggingNodeRect) {
        initialMouseCoordinates = {
          x: activatorCoordinates.x,
          y: activatorCoordinates.y,
        };
        initialDraggingNodeRect = draggingNodeRect;
      }

      const deltaX = activatorCoordinates.x - initialMouseCoordinates.x;
      const deltaY = activatorCoordinates.y - initialMouseCoordinates.y;

      return {
        ...transform,
        x: transform.x + deltaX - horizontalCorrection,
        y: transform.y + deltaY - verticalCorrection,
      };
    }

    return transform;
  };
};
